import React, { useMemo } from "react";
import { Page, Document, View } from "@react-pdf/renderer";
import PDFHeader, { PDFHeaderProps } from "./Header";
import { makePdfStyleSheet } from "./styles";
import PDFFooter, { PDFFooterProps } from "./Footer";
import PDFAssinaturas from "./components/Assinaturas/index";

interface PDFLayoutProps {
  headerProps: PDFHeaderProps;
  footerProps?: PDFFooterProps;
  children?: React.ReactNode;
  orientation?: "landscape" | "portrait";
  fontSize?: number;
  lineHeight?: number;
  includeDocument?: boolean;
  extraPages?: React.ReactNode[];
  assinaturas?: {
    cargoNome?: string;
    pessoaNome?: string;
  }[];
  paddings?: {
    header: string;
    body: string;
    footer: string;
  };
}

function PDFLayout({
  headerProps,
  footerProps,
  children,
  orientation,
  fontSize = 9,
  includeDocument = true,
  extraPages,
  lineHeight,
  assinaturas = [],
  paddings,
}: PDFLayoutProps) {
  const styles = makePdfStyleSheet({
    body: {
      fontSize,
      lineHeight,
    },
    paddings,
  });

  const Wrapper = useMemo(
    () => (includeDocument ? Document : React.Fragment),
    [includeDocument]
  );

  return (
    <Wrapper>
      <Page size="A4" style={styles.page} wrap orientation={orientation}>
        <PDFHeader
          {...headerProps}
          styles={{ ...styles, ...headerProps.styles }}
        />

        <View style={styles.body}>
          {children}

          {assinaturas.length ? (
            <PDFAssinaturas assinaturas={assinaturas} />
          ) : null}
        </View>

        {footerProps ? <PDFFooter {...footerProps} styles={styles} /> : null}
      </Page>

      {extraPages}
    </Wrapper>
  );
}

export default PDFLayout;
